import ImageBackgroundSettings, { imageOnlySettings } from './ImageBackgroundSection';
import FullBackgroundSettings from './FullBackgroundSettings';
import OfferLayoutSettings, { customLayoutProblem, enabledCards } from './OfferLayoutSettings';
import MonsoonPreview from './MonsoonPreview';
import { festivalDefaults } from './FestivalSettings';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import mobSectionApi from '../../../services/mobsectionapi';

// Mobile section create/edit form (theme-aware)
const SectionForm = ({
  section,
  themes = [],
  defaultThemeId = 1,
  defaultSectionFor = 1,
  onClose
}) => {
  const isEditMode = !!section;

  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    title: '',
    presentationConfig: { ...festivalDefaults },
    themeId: defaultThemeId,
    secType: 1,
    noofrows: 1,
    sectionFor: defaultSectionFor,
    seeAll: 0,
    url: '',
    status: 1
  });

  

  useEffect(() => {
    if (section) {
      setFormData({
        title: section.title || '',
        presentationConfig: { ...festivalDefaults, ...section.presentationConfig },
        themeId: section.themeId || defaultThemeId,
        secType: section.secType || 1,
        noofrows: section.noofrows || 1,
        sectionFor: section.sectionFor || defaultSectionFor,
        seeAll: section.seeAll != null ? section.seeAll : 0,
        url: section.url || '',
        status: section.status ?? 1
      });
    } else {
      setFormData((p) => ({
        ...p,
        title: '',
        presentationConfig: { ...festivalDefaults },
        themeId: defaultThemeId,
        secType: 1,
        noofrows: 1,
        sectionFor: defaultSectionFor,
        seeAll: 0,
        url: '',
        status: 1
      }));
    }
  }, [section, defaultThemeId, defaultSectionFor]);

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  // ✅ handle switch properly
  if (type === 'checkbox') {
    setFormData((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
      ...(name === 'seeAll' && !checked ? { url: '' } : {}) // clear url if off
    }));
    return;
  }

  setFormData((prev) => ({ ...prev, [name]: value }));
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    if (Number(formData.secType) === 6) {
      const problem = customLayoutProblem(formData.presentationConfig, enabledCards(section));
      if (problem) { alert(problem); return; }
    }
    setSubmitting(true);
    try {
      const payload = {
        title: formData.title,
        ...([6, 8, 9].includes(Number(formData.secType)) ? { presentationConfig: Number(formData.secType) === 6 ? { layout: formData.presentationConfig.layout || 'grid', ...(formData.presentationConfig.layout === 'custom' ? { rows: formData.presentationConfig.rows } : {}) } : Number(formData.secType) === 8 ? { ...formData.presentationConfig, layout: 'grid' } : imageOnlySettings(formData.presentationConfig) } : {}),
        themeId: parseInt(formData.themeId),
        secType: parseInt(formData.secType),
        noofrows: parseInt(formData.noofrows),
        seeAll: parseInt(formData.seeAll) || 0,
        url: (Number(formData.secType) === 6 || parseInt(formData.seeAll) === 1 ? (formData.url || '').trim() : null),
        sectionFor: parseInt(formData.sectionFor),
        status: parseInt(formData.status)
      };

      let response;
      if (isEditMode) {
        response = await mobSectionApi.updateSection({ id: section.id, ...payload });
      } else {
        response = await mobSectionApi.createSection(payload);
      }

      if (response?.success === false) throw new Error(response.message || 'Unable to save section');
      onClose?.();
    } catch (error) {
      console.error('Error saving section:', error);
      alert(error?.response?.data?.message || error.message || 'Unable to save section. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered size={[6, 8, 9].includes(Number(formData.secType)) ? "lg" : undefined}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? 'Edit Section' : 'Create Section'}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Theme</Form.Label>
            <Form.Select name="themeId" value={formData.themeId} onChange={handleChange}>
              {(themes || []).map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name} ({t.code})
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Section Title</Form.Label>
            <Form.Control
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter section title"
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Section Type</Form.Label>
                <Form.Select name="secType" value={formData.secType} onChange={handleChange}>
                  <option value={1}>Banner</option>
                  <option value={2}>Products Card</option>
                  <option value={3}>Recommended Product Page</option>
                  <option value={4}>Brands</option>
                  <option value={5}>Banner with Two Row Products</option>
                  <option value={6}>Monsoon Offer</option>
                  <option value={8}>Full-background image cards</option>
                  <option value={9}>Image grid with full background</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>No. of Rows</Form.Label>
                <Form.Control
                  type="number"
                  name="noofrows"
                  value={formData.noofrows}
                  onChange={handleChange}
                  min={1}
                />
              </Form.Group>
            </Col>
          </Row>
          {Number(formData.secType) === 9 && <ImageBackgroundSettings value={formData.presentationConfig} onChange={config => setFormData(p => ({ ...p, presentationConfig: config }))} section={{...section, mobrow:section?.mobrow || []}} />}
          {Number(formData.secType) === 8 && <FullBackgroundSettings value={formData.presentationConfig} onChange={config => setFormData(p => ({ ...p, presentationConfig: config }))} title={formData.title} background={section?.bannerImg} rows={section?.mobrow} />}
          {Number(formData.secType) === 6 && <>
            <OfferLayoutSettings value={formData.presentationConfig} onChange={config => setFormData(p => ({ ...p, presentationConfig: config }))} section={section} isNew={!isEditMode} />
            <MonsoonPreview section={{ ...section, ...formData, mobrow: section?.mobrow || [] }} />
          </>}
          <Row className="g-3 mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label className="d-block">See All</Form.Label>
                <Form.Check
                  type="switch"
                  id="seeAllSwitchWeb"
                  name="seeAll"
                  checked={parseInt(formData.seeAll) === 1}
                  onChange={handleChange}
                  label={parseInt(formData.seeAll) === 1 ? 'Enabled' : 'Disabled'}
                />
              </Form.Group>
            </Col>

            {parseInt(formData.seeAll) === 1 && (
              <Col md={8}>
                <Form.Group>
                  <Form.Label>See All URL</Form.Label>
                  <Form.Control
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                    placeholder="/offers or /category/xyz"
                  />
                  <div className="text-muted small mt-1">
                    Tip: Use relative URL. It will open on website/app.
                  </div>
                </Form.Group>
              </Col>
            )}
          </Row>


          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Section For</Form.Label>
                <Form.Select name="sectionFor" value={formData.sectionFor} onChange={handleChange}>
                  <option value={1}>Home Page</option>
                  <option value={2}>Offer Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select name="status" value={formData.status} onChange={handleChange}>
                  <option value={1}>Active</option>
                  <option value={2}>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={submitting}>
            {submitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Saving...
              </>
            ) : (
              isEditMode ? 'Update' : 'Create'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SectionForm;

